import { observable, action, runInAction } from "mobx";
import * as API from "../../../api/m/applogin";
import { MDialog } from "@weapp/ui";
import { getLabel, weappSDK } from "@weapp/utils";

const { toast } = MDialog;

class MAppQrcodeStore {

    @observable inviteInfos: any[] = []
    @observable etoken: any = '';
    @observable jsessionid: any = window.ETEAMSID;

    @action
    init = () => {
    };

    @action
    appLogin = () => {
        this.etoken = this.getQueryString('etoken');
        API.appLogin(this.etoken, this.jsessionid)
            .then((result: any) => {
                runInAction(() => {
                    if (result?.code === 200) {
                        if (result.data?.qiyuesuoUrl?.authUrl) {
                            sessionStorage.setItem('layout_qys_scan', '1');
                            window.location.href = result.data.qiyuesuoUrl.authUrl;
                        } else {
                            toast({
                                content: result.msg,
                            });
                            weappSDK.customSDK.invoke("closeWindow", {
                                success: function (res: any) { }
                            })
                        }

                    } else if (result.msg) {
                        toast({
                            content: result.msg,
                        });
                    } else {
                        if (result.data.errorMsg) {
                            toast({
                                content: getLabel('115230', '契约锁配置错误，请联系管理员处理！')
                            });
                        }
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    @action
    getQueryString = (key: any) => {
        var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }

}

const instance = new MAppQrcodeStore();

export default instance;
